import { useTranslation } from 'react-i18next'

import { RequestsWidget } from '../../../Request'
import { ProfileEntityWidgetItemContent } from '../../../Widget'

import { getServiceRequestListItemProps } from './EmailProfileWidgetAttachedServiceRequests.utils'

function EmailProfileWidgetAttachedServiceRequests({
  initiallyExpanded,
  isSkeleton,
  requests,
  widgetProps,
}) {
  const { t } = useTranslation()

  return isSkeleton || requests?.length > 0 ? (
    <RequestsWidget
      getItemPropsFromValue={getServiceRequestListItemProps}
      isSkeleton={isSkeleton}
      items={requests}
      widgetContentItemsProps={{
        itemProps: {
          ContentContainer: ProfileEntityWidgetItemContent,
        },
        title: t('EmailProfile.AttachedServiceRequestsWidgetListTitleKey', {
          count: requests?.length,
        }),
      }}
      widgetProps={{
        ...widgetProps,
        initiallyExpanded,
        title: t('EmailProfile.AttachedServiceRequestsWidgetTitleKey'),
      }}
    />
  ) : null
}

export default EmailProfileWidgetAttachedServiceRequests
